import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import React from "react";
import { getMobileOperatingSystem } from "../common/CommonMethods.js";

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */

const GotoCareemAppButton = () => {
  const customTheme = createMuiTheme({
    palette: {
      primary: { main: "#3AB54E" },
    },
    typography: {
      button: {
        textTransform: "none",
      },
    },
    shape: {
      borderRadius: 40,
    },
    overrides: {
      MuiButton: {
        label: {
          color: "#ffffff",
          fontSize: "large",
          fontWeight: "bold",
        },
      },
    },
  });

  const appStoreUrl =
    "https://apps.apple.com/us/app/careem-rides-food-delivery/id592978487";
  const playStoreUrl =
    "https://play.google.com/store/apps/details?id=com.careem.acma&hl=en&gl=US";

  const openApp = () => {
    setTimeout(() => {
      const mobileOs = getMobileOperatingSystem();
      if (mobileOs === "iOS") {
        window.location.href = appStoreUrl;
      } else {
        window.location.href = playStoreUrl;
      }
    }, 20);
    window.location.href = "careem://open";
  };
  return (
    <p className="open-careem-button-container">
      <ThemeProvider theme={customTheme}>
        <Button
          variant="contained"
          color="primary"
          style={{ minWidth: "220px" }}
          onClick={openApp}
        >
          Open Careem
        </Button>
      </ThemeProvider>
    </p>
  );
};

export default GotoCareemAppButton;
